import script from "./questionCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./questionCreate.vue?vue&type=script&setup=true&lang=js"

import "./questionCreate.vue?vue&type=style&index=0&id=78933763&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78933763"]])

export default __exports__